import React from 'react';
import { Icon } from 'ui';

const ElementLibrarySearch = props => {
  const query = props.value;

  return (
    <div className="ElementLibrary-search">
      <input
        className="NewInput NewInput--white NewInput--fw"
        placeholder={props.i18n.search}
        onChange={props.search}
        value={query}
      />
      <Icon
        name={query ? 'close-circle' : 'search'}
        onClick={query ? props.clearSearchInput : null}
      />
    </div>
  );
};

export default ElementLibrarySearch;
